import React, {Fragment, useEffect, useState} from "react";
import {getParams, getSelectedOption} from "../../utils/hooks/getParams";

import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import {getFirmOptions} from "../../actions/user";

const FilterByFirm = (props) => {

    const dispatch = useDispatch();
    const {getPageItems, is_filter = false} = props;
    const {
        firm_options
    } = useSelector(state => state.user);

    useEffect(() => {
        dispatch(getFirmOptions());
    }, [])

    const [currentFirm, setCurrentFirm] = useState(Number(getParams().firm_id) || '');
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        const params = getParams();
        if (!isFirst) {
            if (is_filter) {
                dispatch(getPageItems({firm_id: currentFirm, without_relationship: true}))
            } else {
                dispatch(getPageItems(1, params))
            }
        }
    }, [currentFirm])

    useEffect(() => {
        setIsFirst(false);
    }, [])


    const [firmItems, setFirmItems] = useState([
        {
            label: 'Tanlang',
            value: ''
        }
    ]);
    const handleSelect = (data, type) => {
        setCurrentFirm(data.value);
        if (data.value != '') {
            const params = getParams();
            params.firm_id = data.value;
            const url = new URL(window.location);
            url.searchParams.set('page', 1);
            url.searchParams.set('firm_id', data.value);
            window.history.pushState({}, '', url);
        } else {
            const url = new URL(window.location);
            url.searchParams.delete('firm_id');
            window.history.pushState({}, '', url);
        }
    };
    useEffect(() => {
        if (firm_options.length > 0) {
            let items = [
                {
                    label: 'Tanlang',
                    value: ''
                }
            ];
            firm_options.map(item => items.push({
                label: item?.name,
                value: item?.id
            }))
            setFirmItems(items);
        }
    }, [firm_options])
    return (
        <Fragment>

            <Select styles={customStyles}
                    value={getSelectedOption(currentFirm, firmItems)}
                    options={firmItems}
                    onChange={handleSelect}
                    menuPortalTarget={document.body}
                    menuPosition={'fixed'}
            />

        </Fragment>
    )
}
const customStyles = {
    ///.....
    menuPortal: provided => ({...provided, zIndex: 9999}),
    menu: provided => ({...provided, zIndex: 9999})
    ///.....
}
export default FilterByFirm;